import React, { useEffect, useState } from 'react';
import Head from '../../../layout/head/Head';
import Content from '../../../layout/content/Content';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, Col, DataTableBody, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent, PreviewAltCard, Row, RSelect } from '../../../components/Component';
import { useNavigate, useParams } from 'react-router';
import { Link } from "react-router-dom";
import AuthTenantPageError from '../../error/AuthTenantPageError';
import AuthTenantLoader from '../../loaders/AuthTenantLoader';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { useDispatch } from 'react-redux';
import { fail_retrieve_specific_tenant_product_details, loading_retrieve_specific_tenant_product_details, reset_retrieve_specific_tenant_product_details, success_retrieve_specific_tenant_product_details } from '../../../reducers/auth_tenant/retrieve_specific_tenant_product_details_Slice';
import { ADD_PRODUCT_STOCK_ERROR_MSG, ADD_PRODUCT_STOCK_SUCCESS_MSG, RETRIEVE_BRANDS_ERROR_MSG, RETRIEVE_BRANDS_SUCCESS_MSG, RETRIVE_ADD_STOCK_DETAILS_ERROR_MSG, RETRIVE_ADD_STOCK_DETAILS_SUCCESS_MSG, RETRIVE_SPECIFIC_TENANT_PRODUCT_DETAILS_ERROR_MSG, RETRIVE_SPECIFIC_TENANT_PRODUCT_DETAILS_SUCCESS_MSG, TENANT_UPDATE_PRODUCT_DETAILS_ERROR_MSG, TENANT_UPDATE_PRODUCT_DETAILS_SUCCESS_MSG, UPDATE_PRODUCT_VIEWABLE_ON_WEBSITE_ERROR_MSG, UPDATE_PRODUCT_VIEWABLE_ON_WEBSITE_SUCCESS_MSG, UPDATE_TENANT_PRODUCT_IMAGE_ERROR_MSG, UPDATE_TENANT_PRODUCT_IMAGE_SUCCESS_MSG } from '../../../utils/error_success_messages';
import * as app_consts from "../../../utils/app_consts";
import { ADD_STOCK_TO_PRODUCT_API, RETRIEVE_ADD_STOCK_DETAILS_API, RETRIEVE_SPECIFIC_TENANT_PRODUCT_DETAILS_API, RETRIEVE_TENANT_SYSTEM_BRANDS_API, TENANT_TOGGLE_PRODUCT_VIEWABLE_ON_WEBSTORE_API, TENANT_UPDATE_PRODUCT_DETAILS_API, TENANT_UPDATE_PRODUCT_IMAGE_API } from '../../../api/api_data';
import { addThreeDots, formatToSentenceCase, joinWithCommas, messageToast } from '../../../utils/Utils';
import { useSelector } from 'react-redux';
import CardTabs from '../../components/cards/CardTabs';
import AuthTenantNoData from '../../error/AuthTenantNoData';
import { Alert, Badge, Card, DropdownItem, DropdownMenu, DropdownToggle, Modal, ModalBody, ModalHeader, Spinner, UncontrolledDropdown } from 'reactstrap';
import { fail_retreive_add_stock_details, loading_retreive_add_stock_details, reset_retreive_add_stock_details, success_retreive_add_stock_details } from '../../../reducers/auth_tenant/retreive_add_stock_details_Slice';
import TextInput from '../../components/inputs/TextInput';
import { fail_add_product_stock, loading_add_product_stock, reset_add_product_stock, success_add_product_stock } from '../../../reducers/auth_tenant/add_product_stock_Slice';
import moment from 'moment';
import { fail_update_tenant_product_image, loading_update_tenant_product_image, reset_update_tenant_product_image, success_update_tenant_product_image } from '../../../reducers/auth_tenant/update_tenant_product_image_Slice';
import { fail_tenant_update_product_details, loading_tenant_update_product_details, reset_tenant_update_product_details, success_tenant_update_product_details } from '../../../reducers/auth_tenant/tenant_update_product_details_Slice';
import isEqual from 'lodash.isequal';
import ViewSpecificProductDetailsModal from '../../../components/modal/ViewSpecificProductDetailsModal';
import ViewHistoryDetailsModal from '../../../components/modal/ViewHistoryDetailsModal';
import { fail_update_product_viewable_on_webstore, loading_update_product_viewable_on_webstore, reset_update_product_viewable_on_webstore, success_update_product_viewable_on_webstore } from '../../../reducers/auth_tenant/update_product_viewable_on_webstore_Slice';
import { fail_retrieve_brands_list, loading_retrieve_brands_list, reset_retrieve_brands_list, success_retrieve_brands_list } from '../../../reducers/auth_tenant/retrieve_brands_list_Slice';
import InventoryHistoryPDF from '../../../components/pdf/InventoryHistoryPDF';
import { PDFViewer } from '@react-pdf/renderer';

const initial_add_stock_state = { product_id: "", units: "", warehouse_site_id: "", color: "", packet_size: "", adjustment_type: "", reason: "" };
const initial_product_image_data = { product_id: "", image: "" };

const ProductDetails = ({ tenant_info, user_info }) => {

  const { product_id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page_data, setPageData] = useState([]);
  const dispatch = useDispatch();
  const [activeCardTab, setActiveCardTab] = useState(() => {
    const savedTab = localStorage.getItem('productDetailsActiveTab');
    return savedTab || "Main Info";
  });
  const [adjust_stock_modal, setAdjustStockModal] = useState(false);
  const [adjust_stock_loading, setAdjustStockLoading] = useState(false);
  const [retrieve_stock_loading, setRetrieveStockLoading] = useState(false);
  const [retrieve_adjust_stock_data, setRetreiveAdjustStockData] = useState(false);
  const [add_product_stock_form_data, setAddProductStockFormData] = useState(initial_add_stock_state);
  const [colors_map_data, setColorsMapData] = useState([]);
  const [packet_size_map_data, setPacketSizeMapData] = useState([]);
  const [warehouse_site_map_data, setWarehouseSiteMapData] = useState([]);
  const [add_product_stock_error, setProductStockError] = useState("");
  const [grouped_warehouse_data, setGroupedWarehouseData] = useState([]);
  const [upload_logo_modal, setUploadImageLogo] = useState(false);
  const [upload_product_image_loading, setUploadProductImageLoading] = useState(false);
  const [upload_product_image_error, setUploadProductImageError] = useState("");
  const [upload_image_formData, setUploadImageFormData] = useState(initial_product_image_data);
  const [selected_edit_param, setSelectedEditParams] = useState([]);
  const [edit_toggle, setEditToggle] = useState(false);
  const [edit_label, setEditLabel] = useState([]);
  const [editError, setEditError] = useState("");
  const [editLoading, setEditLoading] = useState(false);
  const [viewable_on_webstore_loading, setViewableOnWebstoreLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);


  const [inputPacketSizeValue, setInputPacketSizeValue] = useState("");
  const [bubblesPacketSize, setBubblesPacketSize] = useState([]);

  const [inputColourseValue, setInputColoursValue] = useState("");
  const [bubblesColours, setBubblesColours] = useState([]);

  const [view_specific_product_details_modal, setViewSpecificProductDetailsModal] = useState();
  const [selectedSpecificProductDetails, setSelectedProductDetails] = useState([]);

  const [view_history_modal, setViewHistoryModal] = useState(false);
  const [selectedHistory, setSelectedHistory] = useState([]);
  const [brands, setBrands] = useState([]);

  const [historyView, setHistoryView] = useState("table");

  useEffect(() => {
    localStorage.setItem('productDetailsActiveTab', activeCardTab);
  }, [activeCardTab]);

  useEffect(() => {
    const handleBackButton = () => {
      localStorage.setItem('productsListScrollPosition', window.scrollY);
    };

    window.addEventListener('popstate', handleBackButton);
    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, []);

  const [currentReservedOrdersItemsPage, setCurrentReservedOrderstemsPage] = useState(1);
  const [reservedOrdersPerPage] = useState(10);

  const indexOfLastReservedOrderItem = currentReservedOrdersItemsPage * reservedOrdersPerPage;
  const indexOfFirstDispatchItem = indexOfLastReservedOrderItem - reservedOrdersPerPage;
  const currentReservedOrderItems = page_data?.reserved_products?.slice(indexOfFirstDispatchItem, indexOfLastReservedOrderItem);

  const paginateReservedOrders = (pageNumber) => setCurrentReservedOrderstemsPage(pageNumber);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const open_view_specific_product_details_modal = (warehouse_site_id, color, size) => {
    setViewSpecificProductDetailsModal(true);
    setSelectedProductDetails({ warehouse_site_id: warehouse_site_id, product_id: product_id, color: color, size: size });
  };

  const close_view_specific_product_details_modal = () => {
    setViewSpecificProductDetailsModal(false);
    setSelectedProductDetails([]);
  };

  const handlePacketSizeKeyDown = (e) => {
    if (e.key === "Enter" && inputPacketSizeValue.trim())
    {
      setBubblesPacketSize([...bubblesPacketSize, inputPacketSizeValue.trim()]);
      setSelectedEditParams({ ...selected_edit_param, ["value"]: [...bubblesPacketSize, inputPacketSizeValue.trim()] });
      setInputPacketSizeValue(""); // Clear input
    }
  };

  const removePacketSizeBubble = (index) => {
    setBubblesPacketSize(bubblesPacketSize.filter((_, i) => i !== index));
    setSelectedEditParams({ ...selected_edit_param, ["value"]: bubblesPacketSize.filter((_, i) => i !== index) });
  };

  const handleColorKeyDown = (e) => {
    if (e.key === "Enter" && inputColourseValue.trim())
    {
      setBubblesColours([...bubblesColours, inputColourseValue.trim()]);
      setSelectedEditParams({ ...selected_edit_param, ["value"]: [...bubblesColours, inputColourseValue.trim()] });
      setInputColoursValue(""); // Clear input
    }
  };

  const removeColorsBubble = (index) => {
    setBubblesColours(bubblesColours.filter((_, i) => i !== index));
    setSelectedEditParams({ ...selected_edit_param, ["value"]: bubblesColours.filter((_, i) => i !== index) });
  };

  const processInventoryData = (inventory) => {
    if (!inventory) return [];

    let balance = 0; // Initial balance

    const updatedInventory = [...inventory].reverse().map((item) => {
      balance += item.adjustment_type === "add"
        ? parseFloat(item.units)
        : -parseFloat(item.units);

      return {
        ...item,
        balance: balance.toFixed(0),
      };
    });

    return updatedInventory.reverse(); // Reverse again to restore original order
  };
  // Get current list, pagination
  const processedInventory = processInventoryData(page_data?.recent_product_inventory);

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = processedInventory.slice(indexOfFirstItem, indexOfLastItem);

  // Retreive Product
  useEffect(() => {
    retreive_product_details();
    retrieve_brands();
  }, []);

  // Retrieve Product
  const retreive_product_details = () => {
    setError("");
    setLoading(true);
    dispatch(tenant_auth_actions_helper(loading_retrieve_specific_tenant_product_details, success_retrieve_specific_tenant_product_details, fail_retrieve_specific_tenant_product_details, RETRIVE_SPECIFIC_TENANT_PRODUCT_DETAILS_ERROR_MSG, RETRIVE_SPECIFIC_TENANT_PRODUCT_DETAILS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_SPECIFIC_TENANT_PRODUCT_DETAILS_API}/${product_id}`));
  };

  // Listener
  const retrieve_specific_tenant_product_details_listener = useSelector((state) => state.retrieve_specific_tenant_product_details.retrieve_specific_tenant_product_details);

  useEffect(() => {
    if (retrieve_specific_tenant_product_details_listener.status !== app_consts.IDLE)
    {
      if (retrieve_specific_tenant_product_details_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_specific_tenant_product_details_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_specific_tenant_product_details_listener.message);
          messageToast(retrieve_specific_tenant_product_details_listener.message, app_consts.FAIL);
        } else if (retrieve_specific_tenant_product_details_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_specific_tenant_product_details_listener.data);
          setAddProductStockFormData({ ...add_product_stock_form_data, ["product_id"]: product_id });
          setGroupedWarehouseData(groupBySiteName(retrieve_specific_tenant_product_details_listener.data?.grouped_products_inventory));
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_specific_tenant_product_details());
      }
    }
  }, [retrieve_specific_tenant_product_details_listener]);


  const retrieve_brands = () => {
    dispatch(tenant_auth_actions_helper(loading_retrieve_brands_list, success_retrieve_brands_list, fail_retrieve_brands_list, RETRIEVE_BRANDS_ERROR_MSG, RETRIEVE_BRANDS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_SYSTEM_BRANDS_API}`));
  };

  // Listener
  const retrieve_brands_list_listener = useSelector((state) => state.retrieve_brands_list.retrieve_brands_list);

  useEffect(() => {
    if (retrieve_brands_list_listener.status !== app_consts.IDLE)
    {
      if (retrieve_brands_list_listener.status === app_consts.LOADING)
      {
        console.log("Brands Loading");
      } else
      {
        if (retrieve_brands_list_listener.status === app_consts.FAIL)
        {
          messageToast(retrieve_brands_list_listener.message, app_consts.FAIL);
        } else if (retrieve_brands_list_listener.status === app_consts.SUCCESS)
        {
          const remap_brands = retrieve_brands_list_listener.data?.settings?.map((set) => { return { value: set, label: set }; });
          setBrands(remap_brands);
        }
        dispatch(reset_retrieve_brands_list());
      }
    }
  }, [retrieve_brands_list_listener]);


  const groupBySiteName = (inventory) => {
    return inventory.reduce((acc, item) => {
      const { site_name } = item;

      if (!acc[site_name])
      {
        acc[site_name] = [];
      }

      acc[site_name].push(item);
      return acc;
    }, {});
  };

  // Card Tabs
  const tabs = [
    {
      tabName: "Main Info"
    },
    {
      tabName: "Warehouse Inventory"
    },
    {
      tabName: "Inventory History"
    },
    {
      tabName: "Reserved Orders"
    }
  ];


  const open_retrieve_stock_data_modal = () => {
    setAdjustStockModal(true);
    setRetrieveStockLoading(true);
    // 
    dispatch(tenant_auth_actions_helper(loading_retreive_add_stock_details, success_retreive_add_stock_details, fail_retreive_add_stock_details, RETRIVE_ADD_STOCK_DETAILS_ERROR_MSG, RETRIVE_ADD_STOCK_DETAILS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_ADD_STOCK_DETAILS_API}/${product_id}`));
  };
  // 
  const retreive_add_stock_details_listener = useSelector((state) => state.retreive_add_stock_details.retreive_add_stock_details);


  useEffect(() => {
    if (retreive_add_stock_details_listener.status !== app_consts.IDLE)
    {
      if (retreive_add_stock_details_listener.status === app_consts.LOADING)
      {
        setRetrieveStockLoading(true);
      } else
      {
        setRetrieveStockLoading(false);
        if (retreive_add_stock_details_listener.status === app_consts.FAIL)
        {
          messageToast(retreive_add_stock_details_listener.message, app_consts.FAIL);
        } else if (retreive_add_stock_details_listener.status === app_consts.SUCCESS)
        {
          setRetreiveAdjustStockData(retreive_add_stock_details_listener.data);

          const product = retreive_add_stock_details_listener?.data?.product;

          // Put Colors and Packet Size In Map
          const colors_map = product?.colors?.map((color) => {
            return {
              label: color,
              value: color,
            };
          });

          const packet_size_map = product?.packet_sizes?.map((packet_size) => {
            return {
              label: packet_size,
              value: packet_size,
            };
          });

          const warehouse_site_map = retreive_add_stock_details_listener?.data?.warehouse_sites?.map((site) => {
            return {
              label: `${site?.name} - ${site?.type}`,
              value: site?.id
            };
          });


          setWarehouseSiteMapData(warehouse_site_map);
          setColorsMapData(colors_map);
          setPacketSizeMapData(packet_size_map);
        }
        dispatch(reset_retreive_add_stock_details());
      }
    }
  }, [retreive_add_stock_details_listener]);


  const close_retrieve_stock_data_modal = () => {
    setColorsMapData([]);
    setPacketSizeMapData([]);
    setAdjustStockModal("");
    setRetrieveStockLoading("");
  };

  const handle_submit_add_product_stock = () => {
    setProductStockError("");
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_add_product_stock, success_add_product_stock, fail_add_product_stock, ADD_PRODUCT_STOCK_ERROR_MSG, ADD_PRODUCT_STOCK_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${ADD_STOCK_TO_PRODUCT_API}`, add_product_stock_form_data));
  };

  // Listener
  const add_product_stock_listener = useSelector((state) => state.add_product_stock.add_product_stock);

  useEffect(() => {
    if (add_product_stock_listener.status !== app_consts.IDLE)
    {
      if (add_product_stock_listener.status === app_consts.LOADING)
      {
        setAdjustStockLoading(true);
        setProductStockError("");
      } else
      {
        setAdjustStockLoading(false);
        if (add_product_stock_listener.status === app_consts.FAIL)
        {
          setProductStockError(add_product_stock_listener.message);
          messageToast(add_product_stock_listener.message, app_consts.FAIL);
        } else if (add_product_stock_listener.status === app_consts.SUCCESS)
        {
          messageToast(add_product_stock_listener.message, app_consts.SUCCESS);
          retreive_product_details();
          close_retrieve_stock_data_modal();
        }
        dispatch(reset_add_product_stock());
      }
    }
  }, [add_product_stock_listener]);

  const open_upload_logo_modal = () => {
    setUploadImageFormData(initial_product_image_data);
    setUploadImageLogo(true);
  };

  const close_upload_logo_modal = () => {
    setUploadImageLogo(false);
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];

    if (file)
    {
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];

      if (!allowedTypes.includes(file.type))
      {
        messageToast("Please select a valid image file (PNG, JPEG, JPG.", app_consts.FAIL);
        return;
      }

      setUploadImageFormData({ ...upload_image_formData, ["image"]: file });
    }
  };

  const handle_image_submit = () => {
    setUploadProductImageError("");
    // Update
    const sent_image = { product_id: product_id, image: upload_image_formData.image };

    dispatch(tenant_auth_actions_helper(loading_update_tenant_product_image, success_update_tenant_product_image, fail_update_tenant_product_image, UPDATE_TENANT_PRODUCT_IMAGE_ERROR_MSG, UPDATE_TENANT_PRODUCT_IMAGE_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_UPDATE_PRODUCT_IMAGE_API}`, sent_image));
  };

  // Listener
  const update_tenant_product_image_listener = useSelector((state) => state.update_tenant_product_image.update_tenant_product_image);

  useEffect(() => {
    if (update_tenant_product_image_listener.status !== app_consts.IDLE)
    {
      if (update_tenant_product_image_listener.status === app_consts.LOADING)
      {
        setUploadProductImageLoading(true);
        setUploadProductImageError("");
      } else
      {
        setUploadProductImageLoading(false);
        if (update_tenant_product_image_listener.status === app_consts.FAIL)
        {
          setUploadProductImageError(update_tenant_product_image_listener.message);
          messageToast(update_tenant_product_image_listener.message, app_consts.FAIL);
        } else if (update_tenant_product_image_listener.status === app_consts.SUCCESS)
        {
          messageToast(UPDATE_TENANT_PRODUCT_IMAGE_SUCCESS_MSG, app_consts.SUCCESS);
          setPageData(update_tenant_product_image_listener.data);
          setGroupedWarehouseData(groupBySiteName(update_tenant_product_image_listener.data?.grouped_products_inventory));
          setUploadImageFormData(initial_product_image_data);
          close_upload_logo_modal();
        }
        dispatch(reset_update_tenant_product_image());
      }
    }
  }, [update_tenant_product_image_listener]);

  const init_edit_product_field = (label) => {
    setSelectedEditParams([]);
    setEditToggle(true);
    setEditLabel(label);
    setInputPacketSizeValue("");
  };
  const fin_edit_product_field = () => {
    setSelectedEditParams([]);
    setEditToggle(false);
    setEditLabel("");
  };

  const handleProductDetailsEdit = () => {
    setEditError("");
    const sent_data = { ...selected_edit_param, type: edit_label, product_id: product_id };
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_tenant_update_product_details, success_tenant_update_product_details, fail_tenant_update_product_details, TENANT_UPDATE_PRODUCT_DETAILS_ERROR_MSG, TENANT_UPDATE_PRODUCT_DETAILS_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_UPDATE_PRODUCT_DETAILS_API}`, sent_data));
  };

  // Listener
  const tenant_update_product_details_listener = useSelector((state) => state.tenant_update_product_details.tenant_update_product_details);

  useEffect(() => {
    if (tenant_update_product_details_listener.status !== app_consts.IDLE)
    {
      if (tenant_update_product_details_listener.status === app_consts.LOADING)
      {
        setEditLoading(true);
        setEditError("");
      } else
      {
        setEditLoading(false);
        if (tenant_update_product_details_listener.status === app_consts.FAIL)
        {
          setEditError(tenant_update_product_details_listener.message);
          messageToast(tenant_update_product_details_listener.message, app_consts.FAIL);
        } else if (tenant_update_product_details_listener.status === app_consts.SUCCESS)
        {
          messageToast(TENANT_UPDATE_PRODUCT_DETAILS_SUCCESS_MSG, app_consts.SUCCESS);
          setPageData(tenant_update_product_details_listener.data);
          setGroupedWarehouseData(groupBySiteName(tenant_update_product_details_listener.data?.grouped_products_inventory));
          setUploadImageFormData(initial_product_image_data);
          fin_edit_product_field();
          retreive_product_details();
        }
        dispatch(reset_tenant_update_product_details());
      }
    }
  }, [tenant_update_product_details_listener]);

  const getSelectedOption = (value, options) => {
    return options?.find(option => option.value === value) || null;
  };

  const open_view_history_modal = (timestamp) => {
    const history_field = page_data?.recent_product_inventory?.find((his) => his?.inserted_at === timestamp);
    const restructed_data = { message: history_field?.inventory_audit?.message, timestamp: history_field.inserted_at, link: history_field?.inventory_audit?.dispatch, link_label: "View Order", view_link: `/${tenant_info?.url_prefix}/orders/${history_field?.inventory_audit?.order_ref_number}` };
    setSelectedHistory(restructed_data);
    setViewHistoryModal(true);
  };

  const close_view_history_modal = () => {
    setSelectedHistory([]);
    setViewHistoryModal(false);
  };


  const handleViewAbleOnWebstoreClick = (product_id) => {
    dispatch(tenant_auth_actions_helper(
      loading_update_product_viewable_on_webstore,
      success_update_product_viewable_on_webstore,
      fail_update_product_viewable_on_webstore,
      UPDATE_PRODUCT_VIEWABLE_ON_WEBSITE_ERROR_MSG,
      UPDATE_PRODUCT_VIEWABLE_ON_WEBSITE_SUCCESS_MSG,
      app_consts.GET,
      `/${tenant_info?.url_prefix}/${TENANT_TOGGLE_PRODUCT_VIEWABLE_ON_WEBSTORE_API}/${product_id}`
    ));
  };

  const update_product_viewable_on_webstore_listener = useSelector((state) => state.update_product_viewable_on_webstore.update_product_viewable_on_webstore);

  useEffect(() => {
    if (update_product_viewable_on_webstore_listener.status !== app_consts.IDLE)
    {
      if (update_product_viewable_on_webstore_listener.status === app_consts.LOADING)
      {
        setViewableOnWebstoreLoading(true);
      } else
      {
        setViewableOnWebstoreLoading(false);
        if (update_product_viewable_on_webstore_listener.status === app_consts.FAIL)
        {
          messageToast(update_product_viewable_on_webstore_listener.message, app_consts.FAIL);
        } else if (update_product_viewable_on_webstore_listener.status === app_consts.SUCCESS)
        {

          setPageData({ ...page_data, viewable_on_webstore: update_product_viewable_on_webstore_listener.data?.viewable_on_webstore });
          messageToast(UPDATE_PRODUCT_VIEWABLE_ON_WEBSITE_SUCCESS_MSG, app_consts.SUCCESS);
        }
        dispatch(reset_update_product_viewable_on_webstore());
      }
    }
  }, [update_product_viewable_on_webstore_listener]);

  const handleBackClick = () => {
    localStorage.setItem('productsListScrollPosition', window.scrollY);
    navigate(-1);
  };

  return (
    <>
      <Head title={tenant_info?.name ? `${tenant_info.name} Product Details` : " Product Details"} />
      <Content>
        <BlockHead size="sm">
          <BlockBetween className="g-3">
            <BlockHeadContent>
              <BlockTitle>Product Details</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <Button
                color="light"
                outline
                className="bg-white d-none d-sm-inline-flex"
                onClick={handleBackClick}
              >
                <Icon name="arrow-left"></Icon>
                <span>Back</span>
              </Button>
              <Button
                color="light"
                outline
                className="btn-icon bg-white d-inline-flex d-sm-none"
                onClick={handleBackClick}
              >
                <Icon name="arrow-left"></Icon>
              </Button>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        {
          loading ?
            <>
              <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Product Details..." />
            </>
            :
            <>
              {
                error ?
                  <>
                    <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                  </>
                  :
                  <>
                    {
                      page_data && (page_data?.length > 0 || page_data !== null) ?
                        <>
                          <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />

                          <PreviewAltCard>
                            <div className='mt-4'>

                            </div>
                            {
                              activeCardTab === "Main Info" && (
                                <>
                                  <Row className="pb-5">
                                    <Col lg={6}>
                                      {page_data?.product_img ? (
                                        <>
                                          <Card className="product-card" style={{ height: "350px" }}>
                                            <div
                                              className="product-thumb"
                                              style={{
                                                height: '350px',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                backgroundColor: '#f9f9f9',
                                                border: '1px dashed #ccc',
                                              }}
                                            >
                                              <img
                                                src={page_data?.product_img}
                                                alt="Logo"
                                                style={{
                                                  maxHeight: '90%', // Keeps it inside the box
                                                  maxWidth: '90%',
                                                  objectFit: 'contain',
                                                  display: 'block',
                                                }}
                                              />
                                            </div>
                                          </Card>
                                          {
                                            (user_info?.roles?.includes(app_consts.UPDATE_PRODUCT_LOWER) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                                              <>
                                                <div className="mt-4 d-flex justify-content-end">
                                                  <Button color="primary" size="md" onClick={(e) => { e.preventDefault(); open_upload_logo_modal(); }}>

                                                    Update Product Image
                                                  </Button>
                                                </div>
                                              </>
                                            )
                                          }
                                        </>
                                      ) : (
                                        <Card className="product-card" style={{ height: '100%' }}>
                                          <div className="product-thumb" style={{ height: '100%' }}>
                                            <div style={{
                                              width: '100%',
                                              height: '100%',  // Take 100% of the container height
                                              display: 'flex',
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                              backgroundColor: '#f0f0f0', // Light gray background
                                              textAlign: 'center',
                                              border: '1px dashed #ccc', // Dashed border to simulate placeholder
                                              fontSize: '18px', // Font size
                                              fontWeight: 'bold', // Make the text bold
                                              fontFamily: 'Arial, sans-serif', // Custom font
                                              flexDirection: "column"
                                            }}>
                                              <div style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                textAlign: 'center',
                                                color: '#333', // Text color
                                                fontSize: '18px', // Font size
                                                fontWeight: 'bold', // Make the text bold
                                                fontFamily: 'Arial, sans-serif', // Custom font
                                              }}>
                                                <p style={{ margin: 0, padding: '5px' }}>YOUR</p>
                                                <p style={{ margin: 0, padding: '5px' }}>IMAGE</p>
                                                <p style={{ margin: 0, padding: '5px' }}>HERE</p>
                                              </div>
                                              <Button color="primary" size="md" onClick={(e) => { e.preventDefault(); open_upload_logo_modal(); }}>
                                                Upload Logo
                                              </Button>
                                            </div>
                                          </div>
                                        </Card>
                                      )}
                                    </Col>
                                    <Col lg={6}>
                                      <form onSubmit={(e) => e.preventDefault()}
                                        onKeyDown={(e) => {
                                          if (e.key === "Enter") e.preventDefault();
                                        }} className="gy-3 form-page_data">
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Name</label>
                                              <span className="form-note">Name/Description</span>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap d-flex align-items-center">
                                                <input disabled={edit_toggle ? !(edit_label === "name") : !edit_toggle} type="text" className="form-control" id="name" name="name" defaultValue={page_data?.name} onChange={(e) => setSelectedEditParams({ ...selected_edit_param, value: e.target.value, type: "name" })} value={edit_toggle && edit_label === "name" ? selected_edit_param?.value : page_data?.name} />
                                                {
                                                  (user_info?.roles?.includes(app_consts.UPDATE_PRODUCT_LOWER) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                                                    <>
                                                      <button
                                                        type="button"
                                                        onClick={(e) => {
                                                          e.preventDefault();
                                                        }}
                                                        style={{
                                                          background: "none",
                                                          border: "none",
                                                          marginLeft: "10px",
                                                          cursor: "pointer",
                                                        }}
                                                        title="Edit"
                                                      >
                                                        {
                                                          !edit_toggle && (
                                                            <>
                                                              <Icon name="edit-alt" onClick={() => init_edit_product_field("name")} style={{ height: 40, width: 40 }} />
                                                            </>
                                                          )
                                                        }
                                                      </button>
                                                    </>
                                                  )
                                                }
                                              </div>
                                              {
                                                (user_info?.roles?.includes(app_consts.UPDATE_PRODUCT_LOWER) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                                                  <>
                                                    {
                                                      edit_toggle && edit_label === "name" && (
                                                        <>
                                                          {editError && (
                                                            <div className="mb-3 w-100 mt-4">
                                                              <Alert color="danger" className="alert-icon">
                                                                <Icon name="alert-circle" /> {editError}{" "}
                                                              </Alert>
                                                            </div>
                                                          )}
                                                          <div className={`d-flex flex-row justify-content-end mt-4`}>
                                                            <Button disabled={editLoading} color="gray" size="md" className="mx-2" onClick={(e) => { e.preventDefault(); fin_edit_product_field(); }}>
                                                              Cancel
                                                            </Button>
                                                            <Button disabled={selected_edit_param?.value ? selected_edit_param?.value === page_data?.name : !selected_edit_param?.value} color="success" size="md" className="mx-2" onClick={(e) => { e.preventDefault(); handleProductDetailsEdit(); }}>
                                                              {editLoading && edit_label === "name" ? <Spinner size="sm" color="light" /> : "Save"}
                                                            </Button>
                                                          </div>
                                                        </>
                                                      )
                                                    }
                                                  </>
                                                )
                                              }
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Brand</label>
                                              <span className="form-note">Brand/Category</span>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap d-flex align-items-center">
                                                {
                                                  edit_toggle && (edit_label === "category") ?
                                                    <>
                                                      <Col size={12}>

                                                        <div className="w-100">
                                                          <RSelect
                                                            options={brands}
                                                            className="w-100"
                                                            placeholder="Search"
                                                            id="category"
                                                            onChange={(e) => {
                                                              setSelectedEditParams({ ...selected_edit_param, value: e.value, type: "category" });
                                                            }}
                                                            value={getSelectedOption(selected_edit_param.value, brands)}
                                                          />
                                                        </div>
                                                      </Col>

                                                    </>
                                                    :
                                                    <>
                                                      <input disabled type="text" className="form-control" id="category" name="category" value={page_data?.category} onChange={(e) => setSelectedEditParams({ ...selected_edit_param, value: e.target.value, type: "category" })} />
                                                    </>


                                                }


                                                {
                                                  (user_info?.roles?.includes(app_consts.UPDATE_PRODUCT_LOWER) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                                                    <>
                                                      <button
                                                        type="button"
                                                        onClick={(e) => {
                                                          e.preventDefault();
                                                        }}
                                                        style={{
                                                          background: "none",
                                                          border: "none",
                                                          marginLeft: "10px",
                                                          cursor: "pointer",
                                                        }}
                                                        title="Edit"
                                                      >
                                                        {
                                                          !edit_toggle && (
                                                            <>
                                                              <Icon name="edit-alt" style={{ height: 40, width: 40 }} onClick={() => init_edit_product_field("category")} />
                                                            </>
                                                          )
                                                        }
                                                      </button>
                                                    </>
                                                  )}
                                              </div>

                                              {
                                                (user_info?.roles?.includes(app_consts.UPDATE_PRODUCT_LOWER) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                                                  <>
                                                    {
                                                      edit_toggle && edit_label === "category" && (
                                                        <>
                                                          {editError && (
                                                            <div className="mb-3 w-100 mt-4">
                                                              <Alert color="danger" className="alert-icon">
                                                                <Icon name="alert-circle" /> {editError}{" "}
                                                              </Alert>
                                                            </div>
                                                          )}
                                                          <div className={`d-flex flex-row justify-content-end mt-4`}>
                                                            <Button disabled={editLoading} color="gray" size="md" className="mx-2" onClick={(e) => { e.preventDefault(); fin_edit_product_field(); }}>
                                                              Cancel
                                                            </Button>
                                                            <Button disabled={selected_edit_param?.value ? selected_edit_param?.value === page_data?.category : !selected_edit_param?.value} color="success" size="md" className="mx-2" onClick={(e) => { e.preventDefault(); handleProductDetailsEdit(); }}>
                                                              {editLoading && edit_label === "category" ? <Spinner size="sm" color="light" /> : "Save"}
                                                            </Button>
                                                          </div>
                                                        </>
                                                      )
                                                    }
                                                  </>
                                                )}
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Product Type</label>
                                              <span className="form-note">Product Type/Placement</span>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap d-flex align-items-center">
                                                <input disabled={edit_toggle ? !(edit_label === "product_type") : !edit_toggle} type="text" className="form-control" id="product_type" name="product_type" defaultValue={page_data?.product_type} onChange={(e) => setSelectedEditParams({ ...selected_edit_param, value: e.target.value, type: "product_type" })} value={edit_toggle && edit_label === "product_type" ? selected_edit_param?.value : page_data?.product_type} />
                                                {
                                                  (user_info?.roles?.includes(app_consts.UPDATE_PRODUCT_LOWER) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                                                    <>
                                                      <button
                                                        type="button"
                                                        onClick={(e) => {
                                                          e.preventDefault();
                                                        }}
                                                        style={{
                                                          background: "none",
                                                          border: "none",
                                                          marginLeft: "10px",
                                                          cursor: "pointer",
                                                        }}
                                                        title="Edit"
                                                      >
                                                        {
                                                          !edit_toggle && (
                                                            <>
                                                              <Icon name="edit-alt" style={{ height: 40, width: 40 }} onClick={() => init_edit_product_field("product_type")} />
                                                            </>
                                                          )
                                                        }
                                                      </button>
                                                    </>
                                                  )
                                                }
                                              </div>

                                              {
                                                (user_info?.roles?.includes(app_consts.UPDATE_PRODUCT_LOWER) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                                                  <>
                                                    {
                                                      edit_toggle && edit_label === "product_type" && (
                                                        <>
                                                          {editError && (
                                                            <div className="mb-3 w-100 mt-4">
                                                              <Alert color="danger" className="alert-icon">
                                                                <Icon name="alert-circle" /> {editError}{" "}
                                                              </Alert>
                                                            </div>
                                                          )}
                                                          <div className={`d-flex flex-row justify-content-end mt-4`}>
                                                            <Button disabled={editLoading} color="gray" size="md" className="mx-2" onClick={(e) => { e.preventDefault(); fin_edit_product_field(); }}>
                                                              Cancel
                                                            </Button>
                                                            <Button disabled={selected_edit_param?.value ? selected_edit_param?.value === page_data?.product_type : !selected_edit_param?.value} color="success" size="md" className="mx-2" onClick={(e) => { e.preventDefault(); handleProductDetailsEdit(); }}>
                                                              {editLoading && edit_label === "product_type" ? <Spinner size="sm" color="light" /> : "Save"}
                                                            </Button>
                                                          </div>
                                                        </>
                                                      )
                                                    }
                                                  </>
                                                )
                                              }
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Status</label>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap d-flex align-items-center">
                                                {
                                                  edit_toggle && edit_label === "status" ?
                                                    <>
                                                      <div className="w-95">
                                                        <RSelect
                                                          options={[{ label: "Active", value: "active" }, { label: "Inactive", value: "inactive" }, { label: "Archive", value: "archive" }]?.map((p) => {
                                                            return (
                                                              {
                                                                label: p?.label,
                                                                value: p?.value
                                                              }
                                                            );
                                                          })}
                                                          className="w-100"
                                                          placeholder="Search"
                                                          value={getSelectedOption(edit_toggle && edit_label === "status" ? selected_edit_param?.value : page_data?.status, [{ label: "Active", value: "active" }, { label: "Inactive", value: "inactive" }, { label: "Archive", value: "archive" }])}
                                                          onChange={(e) => setSelectedEditParams({ ...selected_edit_param, value: e.value, type: "status" })}
                                                        />
                                                      </div>
                                                    </>
                                                    :
                                                    <>
                                                      <input disabled={edit_toggle ? !(edit_label === "status") : !edit_toggle} name="status" type="text" className="form-control" id="site-name" defaultValue={page_data?.status?.toUpperCase()} />
                                                      <button
                                                        type="button"
                                                        onClick={(e) => {
                                                          e.preventDefault();
                                                        }}
                                                        style={{
                                                          background: "none",
                                                          border: "none",
                                                          marginLeft: "10px",
                                                          cursor: "pointer",
                                                        }}
                                                        title="Edit"
                                                      >


                                                        {
                                                          (user_info?.roles?.includes(app_consts.UPDATE_PRODUCT_LOWER) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                                                            <>
                                                              {
                                                                !edit_toggle && (
                                                                  <>
                                                                    <Icon name="edit-alt" style={{ height: 40, width: 40 }} onClick={() => { init_edit_product_field("status"); setSelectedEditParams({ ...selected_edit_param, value: page_data?.status }); }} />
                                                                  </>
                                                                )
                                                              }
                                                            </>
                                                          )
                                                        }
                                                      </button>
                                                    </>
                                                }
                                              </div>
                                              {
                                                (user_info?.roles?.includes(app_consts.UPDATE_PRODUCT_LOWER) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                                                  <>
                                                    {
                                                      edit_toggle && edit_label === "status" && (
                                                        <>
                                                          {editError && (
                                                            <div className="mb-3 w-100 mt-4">
                                                              <Alert color="danger" className="alert-icon">
                                                                <Icon name="alert-circle" /> {editError}{" "}
                                                              </Alert>
                                                            </div>
                                                          )}
                                                          <div className={`d-flex flex-row justify-content-end mt-4`}>
                                                            <Button disabled={editLoading} color="gray" size="md" className="mx-2" onClick={(e) => { e.preventDefault(); fin_edit_product_field(); }}>
                                                              Cancel
                                                            </Button>
                                                            <Button disabled={selected_edit_param?.value ? selected_edit_param?.value === page_data?.status : !selected_edit_param?.value} color="success" size="md" className="mx-2" onClick={(e) => { e.preventDefault(); handleProductDetailsEdit(); }}>
                                                              {editLoading && edit_label === "status" ? <Spinner size="sm" color="light" /> : "Save"}
                                                            </Button>
                                                          </div>
                                                        </>
                                                      )
                                                    }
                                                  </>
                                                )
                                              }
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Sizes</label>
                                              <span className="form-note">Sizes/Packet Sizes</span>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap d-flex align-items-center">
                                                {
                                                  edit_toggle && edit_label === "packet_sizes" ?
                                                    <>
                                                      <Col size={12}>
                                                        <TextInput
                                                          type="text"
                                                          id_val="packet_size"
                                                          value={inputPacketSizeValue}
                                                          colSize="12"
                                                          name="packet_size"
                                                          handleChange={(e) => setInputPacketSizeValue(e.target.value)}
                                                          onKeyDown={handlePacketSizeKeyDown}
                                                          helper="Type and press Enter..."
                                                        />
                                                        <div style={styles.bubbleContainer} className='mt-2'>
                                                          {bubblesPacketSize.map((text, index) => (
                                                            <div key={index} className={page_data?.deletable_sizes?.includes(text) || !page_data?.packet_sizes?.includes(text) ? 'bg-primary' : "bg-gray-500"} style={styles.bubble}>
                                                              {text}
                                                              {
                                                                (page_data?.deletable_sizes?.includes(text) || !page_data?.packet_sizes?.includes(text)) && (
                                                                  <>
                                                                    <span style={styles.close} onClick={() => removePacketSizeBubble(index)}>
                                                                      &times;
                                                                    </span>
                                                                  </>
                                                                )
                                                              }
                                                            </div>
                                                          ))}
                                                        </div>
                                                      </Col>
                                                    </>
                                                    :
                                                    <>
                                                      <input disabled={edit_toggle ? !(edit_label === "packet_sizes") : !edit_toggle} name="packet_sizes" type="text" className="form-control" id="site-name" defaultValue={page_data?.packet_sizes ? addThreeDots(joinWithCommas(page_data?.packet_sizes), 30) : "--"} />

                                                      {
                                                        (user_info?.roles?.includes(app_consts.UPDATE_PRODUCT_LOWER) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                                                          <>
                                                            <button
                                                              type="button"
                                                              onClick={(e) => {
                                                                e.preventDefault();
                                                              }}
                                                              style={{
                                                                background: "none",
                                                                border: "none",
                                                                marginLeft: "10px",
                                                                cursor: "pointer",
                                                              }}
                                                              title="Edit"
                                                            >
                                                              {
                                                                !edit_toggle && (
                                                                  <>
                                                                    <Icon name="edit-alt" style={{ height: 40, width: 40 }} onClick={() => { init_edit_product_field("packet_sizes"); setSelectedEditParams({ ...selected_edit_param, type: "packet_sizes" }); setBubblesPacketSize(page_data?.packet_sizes); }} />
                                                                  </>
                                                                )
                                                              }
                                                            </button>
                                                          </>
                                                        )
                                                      }
                                                    </>
                                                }
                                              </div>

                                              {
                                                (user_info?.roles?.includes(app_consts.UPDATE_PRODUCT_LOWER) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                                                  <>
                                                    {
                                                      edit_toggle && edit_label === "packet_sizes" && (
                                                        <>
                                                          {editError && (
                                                            <div className="mb-3 w-100 mt-4">
                                                              <Alert color="danger" className="alert-icon">
                                                                <Icon name="alert-circle" /> {editError}{" "}
                                                              </Alert>
                                                            </div>
                                                          )}
                                                          <div className={`d-flex flex-row justify-content-end mt-4`}>
                                                            <Button disabled={editLoading} color="gray" size="md" className="mx-2" onClick={(e) => { e.preventDefault(); fin_edit_product_field(); }}>
                                                              Cancel
                                                            </Button>
                                                            <Button disabled={!selected_edit_param?.value || (selected_edit_param?.value?.length === 0) || isEqual(selected_edit_param.value, page_data?.packet_sizes)} color="success" size="md" className="mx-2" onClick={(e) => { e.preventDefault(); handleProductDetailsEdit(); }}>
                                                              {editLoading && edit_label === "packet_sizes" ? <Spinner size="sm" color="light" /> : "Save"}
                                                            </Button>
                                                          </div>
                                                        </>
                                                      )
                                                    }
                                                  </>
                                                )
                                              }
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Colors</label>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap d-flex align-items-center">
                                                {
                                                  edit_toggle && edit_label === "colors" ?
                                                    <>
                                                      <Col size={12}>
                                                        <TextInput
                                                          type="text"
                                                          id_val="color"
                                                          value={inputColourseValue}
                                                          colSize="12"
                                                          name="color"
                                                          handleChange={(e) => setInputColoursValue(e.target.value)}
                                                          onKeyDown={handleColorKeyDown}
                                                          helper="Type and press Enter..."
                                                        />
                                                        <div style={styles.bubbleContainer} className='mt-2'>
                                                          {bubblesColours.map((text, index) => (
                                                            <div key={index} className={page_data?.deletable_colors?.includes(text) || !page_data?.colors?.includes(text) ? 'bg-primary' : "bg-gray-500"} style={styles.bubble}>
                                                              {text}
                                                              {
                                                                (page_data?.deletable_colors?.includes(text) || !page_data?.colors?.includes(text)) && (
                                                                  <>
                                                                    <span style={styles.close} onClick={() => removeColorsBubble(index)}>
                                                                      &times;
                                                                    </span>
                                                                  </>
                                                                )
                                                              }
                                                            </div>
                                                          ))}
                                                        </div>
                                                      </Col>
                                                    </>
                                                    :
                                                    <>
                                                      <input disabled={edit_toggle ? !(edit_label === "colors") : !edit_toggle} name="colors" type="text" className="form-control" id="site-name" defaultValue={page_data?.colors ? addThreeDots(joinWithCommas(page_data?.colors), 30) : "--"} />
                                                      <button
                                                        type="button"
                                                        onClick={(e) => {
                                                          e.preventDefault();
                                                        }}
                                                        style={{
                                                          background: "none",
                                                          border: "none",
                                                          marginLeft: "10px",
                                                          cursor: "pointer",
                                                        }}
                                                        title="Edit"
                                                      >
                                                        {
                                                          (user_info?.roles?.includes(app_consts.UPDATE_PRODUCT_LOWER) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                                                            <>
                                                              {
                                                                !edit_toggle && (
                                                                  <>
                                                                    <Icon name="edit-alt" style={{ height: 40, width: 40 }} onClick={() => { init_edit_product_field("colors"); setSelectedEditParams({ ...selected_edit_param, type: "colors" }); setBubblesColours(page_data?.colors); }} />
                                                                  </>
                                                                )
                                                              }
                                                            </>
                                                          )}
                                                      </button>
                                                    </>
                                                }
                                              </div>
                                              {
                                                (user_info?.roles?.includes(app_consts.UPDATE_PRODUCT_LOWER) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                                                  <>
                                                    {
                                                      edit_toggle && edit_label === "colors" && (
                                                        <>
                                                          {editError && (
                                                            <div className="mb-3 w-100 mt-4">
                                                              <Alert color="danger" className="alert-icon">
                                                                <Icon name="alert-circle" /> {editError}{" "}
                                                              </Alert>
                                                            </div>
                                                          )}
                                                          <div className={`d-flex flex-row justify-content-end mt-4`}>
                                                            <Button disabled={editLoading} color="gray" size="md" className="mx-2" onClick={(e) => { e.preventDefault(); fin_edit_product_field(); }}>
                                                              Cancel
                                                            </Button>
                                                            <Button disabled={!selected_edit_param?.value || (selected_edit_param?.value?.length === 0) || isEqual(selected_edit_param.value, page_data?.colors)} color="success" size="md" className="mx-2" onClick={(e) => { e.preventDefault(); handleProductDetailsEdit(); }}>
                                                              {editLoading && edit_label === "colors" ? <Spinner size="sm" color="light" /> : "Save"}
                                                            </Button>
                                                          </div>
                                                        </>
                                                      )
                                                    }
                                                  </>
                                                )}
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Value</label>
                                              <span className="form-note">Product Price in Zambian Kwacha</span>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap d-flex align-items-center">
                                                <input disabled type="text" className="form-control" id="value" name="value" defaultValue={page_data?.product_value ? `${parseFloat(page_data?.product_value)?.toFixed(2)} ZMW` : "--"} value={page_data?.product_value ? `${parseFloat(page_data?.product_value)?.toFixed(2)} ZMW` : "--"} />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Viewable on Webstore</label>
                                              <span className="form-note">Allowing Sales Rep to View Product on Webstore</span>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="preview-block">
                                              <div className="custom-control custom-switch">
                                                <input
                                                  type="checkbox"
                                                  className="custom-control-input"
                                                  checked={page_data?.viewable_on_webstore}
                                                  id={page_data?.id}
                                                  onClick={() => handleViewAbleOnWebstoreClick(page_data?.id)}
                                                  disabled={!(user_info?.roles?.includes(app_consts.TOGGLE_PRODUCT_VIEWABLE_ON_WEBSTORE) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) || viewable_on_webstore_loading}
                                                />
                                                <label className="custom-control-label" htmlFor={page_data?.id}>

                                                </label>
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                      </form>
                                    </Col>
                                  </Row>

                                  <Modal isOpen={upload_logo_modal} className="modal-dialog-centered" size={"lg"}>
                                    <ModalHeader toggle={!upload_product_image_loading && close_upload_logo_modal}>Upload Logo</ModalHeader>
                                    <ModalBody>
                                      <div
                                        className="product-thumb"
                                        style={{
                                          height: '250px',
                                          width: '100%',
                                          position: 'relative',
                                          border: '1px dashed #ccc',
                                          backgroundColor: '#f9f9f9',
                                          overflow: 'hidden',
                                        }}
                                      >
                                        {upload_image_formData.image ? (
                                          <img
                                            src={URL.createObjectURL(upload_image_formData.image)}
                                            alt="Uploaded Logo"
                                            style={{
                                              width: '100%',
                                              height: '100%',
                                              objectFit: 'contain',
                                              display: 'block',
                                            }}
                                          />
                                        ) : (
                                          <label
                                            htmlFor="imageUpload"
                                            style={{
                                              width: '100%',
                                              height: '100%',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                              flexDirection: 'column',
                                              color: '#777',
                                              fontSize: '16px',
                                              fontWeight: 'bold',
                                              fontFamily: 'Arial, sans-serif',
                                              cursor: 'pointer',
                                              textAlign: 'center',
                                            }}
                                          >
                                            <p style={{ margin: 0 }}>Click to Select Image</p>
                                          </label>
                                        )}

                                        <input
                                          type="file"
                                          id="imageUpload"
                                          accept="image/png, image/jpeg, image/jpg"
                                          style={{ display: 'none' }}
                                          onChange={handleImageUpload}
                                        />
                                      </div>

                                      {upload_product_image_error && (
                                        <div className="mb-3 w-100 mt-4">
                                          <Alert color="danger" className="alert-icon">
                                            <Icon name="alert-circle" /> {upload_product_image_error}{" "}
                                          </Alert>
                                        </div>
                                      )}
                                      <div className={`d-flex flex-row ${upload_image_formData?.image ? "justify-content-between" : "justify-content-end"} mt-4`}>
                                        {
                                          upload_image_formData?.image && (
                                            <>
                                              <Button color="primary" size="md" onClick={(e) => { e.preventDefault(); open_upload_logo_modal(); }}>
                                                Re-upload
                                              </Button>
                                            </>
                                          )
                                        }
                                        <Button color="success" size="md" onClick={(e) => { e.preventDefault(); handle_image_submit(); }} disabled={!upload_image_formData?.image}>
                                          {upload_product_image_loading ? "Uploading Image..." : "Upload Image"}
                                        </Button>
                                      </div>
                                    </ModalBody>
                                  </Modal>
                                </>
                              )
                            }
                            {
                              activeCardTab === "Warehouse Inventory" && (
                                <>
                                  <div className="card-title">
                                    <h4 className="title">Warehouse Inventory</h4>
                                  </div>
                                  <div className='mt-2 justify-content-between d-flex align-center flex-row m-auto'>
                                    <Button
                                      className="toggle d-none d-md-inline-flex"
                                      color="primary"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        open_retrieve_stock_data_modal();
                                      }}
                                    >
                                      <Icon name="plus"></Icon>
                                      <span>Adjust Product Stock</span>
                                    </Button>
                                  </div>
                                  {
                                    grouped_warehouse_data ? (
                                      <div className="warehouse-dashboard">
                                        {Object.entries(grouped_warehouse_data).map(([siteName, items], siteIndex) => (
                                          <div key={siteName} className="site-section">
                                            {siteIndex > 0 && <hr className="divider" />}

                                            <Block size="lg" className="my-4">
                                              <BlockHead>
                                                <BlockBetween>
                                                  <BlockHeadContent>
                                                    <BlockTitle tag="h4" className="text-primary">
                                                      <Icon name="building-fill" className="me-2" />
                                                      {siteName}
                                                    </BlockTitle>
                                                    <Badge color="light" className="ms-2">
                                                      {items.length} {items.length === 1 ? 'item' : 'items'}
                                                    </Badge>
                                                  </BlockHeadContent>
                                                </BlockBetween>
                                              </BlockHead>

                                              <Row className="g-4">
                                                {items.map((item) => (
                                                  <Col sm="6" lg="4" xxl="3" key={item.id}>
                                                    <PreviewAltCard className="h-100 product-card">
                                                      <div className="team">
                                                        <div className="user-card user-card-s2">
                                                          <div className="user-avatar bg-light">
                                                            {item.product_name?.charAt(0) || '?'}
                                                          </div>
                                                          <div className="user-info">
                                                            <h6 className="fw-bold">{item.product_name || "--"}</h6>
                                                            <div className="d-flex gap-2">
                                                              <Badge color="outline-secondary" className="text-capitalize">
                                                                {item?.color ? formatToSentenceCase(item?.color) : "--"}
                                                              </Badge>
                                                              <Badge color="outline-secondary">
                                                                {item?.packet_size ? formatToSentenceCase(item?.packet_size) : "--"}
                                                              </Badge>
                                                            </div>
                                                          </div>
                                                        </div>

                                                        <ul className="team-info">
                                                          <li className="d-flex justify-content-between py-1">
                                                            <span className="text-soft">Total In</span>
                                                            <span className="fw-bold text-success">
                                                              +{item.add_sum || 0}
                                                            </span>
                                                          </li>
                                                          <li className="d-flex justify-content-between py-1">
                                                            <span className="text-soft">Total Out</span>
                                                            <span className="fw-bold text-danger">
                                                              -{item.subtract_sum || 0}
                                                            </span>
                                                          </li>
                                                          <li className="d-flex justify-content-between py-1 border-top border-light">
                                                            <span className="text-soft">Current Balance</span>
                                                            <span className="fw-bold text-primary">
                                                              {item.balance || 0}
                                                            </span>
                                                          </li>
                                                        </ul>

                                                        <div className="team-view">
                                                          <Button
                                                            onClick={(e) => { e.preventDefault(); open_view_specific_product_details_modal(item?.warehouse_site_id, item?.color, item?.packet_size); }}
                                                            color="primary"
                                                            className="btn-block btn-dim d-flex align-items-center justify-content-center"
                                                            size="md"
                                                          >
                                                            <Icon name="eye-fill" className="me-1" />
                                                            <span>View Details</span>
                                                          </Button>
                                                        </div>
                                                      </div>
                                                    </PreviewAltCard>
                                                  </Col>
                                                ))}
                                              </Row>
                                            </Block>
                                          </div>
                                        ))}
                                      </div>
                                    ) : (
                                      <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: "60vh" }}>
                                        <AuthTenantNoData
                                          tenant_info={tenant_info}
                                          no_data_message={
                                            <div className="text-center">
                                              <Icon name="box-seam" size="2x" className="text-muted mb-3" />
                                              <h5 className="text-muted">No Stock Found</h5>
                                              <p className="text-soft">Your inventory will appear here once available</p>
                                            </div>
                                          }
                                        />
                                      </div>
                                    )
                                  }
                                  <ViewSpecificProductDetailsModal isOpen={view_specific_product_details_modal} closeModal={close_view_specific_product_details_modal} data={{ product: page_data, selectedDetails: selectedSpecificProductDetails }} tenant_info={tenant_info} user_info={user_info} />
                                </>
                              )
                            }
                            {
                              activeCardTab === "Inventory History" && (
                                <>
                                  <div className="card-title">
                                    <h5 className="title">Inventory History</h5>
                                    <Button
                                      size="sm"
                                      color={historyView === "table" ? "primary" : "light"}
                                      className="rounded-pill mx-2"
                                      onClick={() => setHistoryView("table")}
                                    >
                                      Table
                                    </Button>

                                    <Button
                                      size="sm"
                                      color={historyView === "pdf" ? "primary" : "light"}
                                      className="rounded-pill mx-2"
                                      onClick={() => setHistoryView("pdf")}
                                    >
                                      PDF
                                    </Button>

                                    {/*<Button
                                      size="sm"
                                      color={historyView === "excel" ? "primary" : "light"}
                                      className="rounded-pill mx-2"
                                      onClick={() => setHistoryView("excel")}
                                    >
                                      Excel
                                    </Button> */}
                                  </div>
                                  <Card>
                                    <div className="card-inner-group">
                                      <div className="card-inner p-0">
                                        {
                                          historyView === "table" && (
                                            <>
                                              <DataTableBody>
                                                <DataTableHead>
                                                  <DataTableRow size="sm">
                                                    <span>Message</span>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span>Size</span>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span>Color</span>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span>Units</span>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span>Balance</span>
                                                  </DataTableRow>
                                                  <DataTableRow size="md">
                                                    <span> Date</span>
                                                  </DataTableRow>
                                                  <DataTableRow size="md">
                                                    <span>Action</span>
                                                  </DataTableRow>
                                                </DataTableHead>
                                                {currentItems?.length > 0
                                                  ? currentItems.map((item, index) => {

                                                    return (
                                                      <DataTableItem key={index}>
                                                        <DataTableRow size="sm">
                                                          <span className="tb-product">
                                                            <span className="">
                                                              {item?.inventory_audit?.message ? addThreeDots(item?.inventory_audit?.message, 60) : "--"}
                                                            </span>
                                                          </span>
                                                        </DataTableRow>
                                                        <DataTableRow>
                                                          <span className="tb-product">
                                                            <span className="tb-sub">{item?.packet_size || "--"}</span>
                                                          </span>
                                                        </DataTableRow>
                                                        <DataTableRow>
                                                          <span className="tb-sub">{item?.color || "--"}</span>
                                                        </DataTableRow>
                                                        <DataTableRow>
                                                          <span className="tb-sub">{item?.units || "0"}</span>
                                                        </DataTableRow>
                                                        <DataTableRow>
                                                          <span className="tb-sub">{item?.balance}</span> {/* Now displaying balance */}
                                                          {item?.adjustment_type === app_consts.ADD_LOWER ? (
                                                            <Icon name="caret-up-fill" className="text-success fs-22px" />
                                                          ) : (
                                                            <Icon name="caret-down-fill" className="text-danger fs-22px" />
                                                          )}
                                                        </DataTableRow>
                                                        <DataTableRow>
                                                          <span className="tb-odr-date">
                                                            {item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}
                                                          </span>
                                                        </DataTableRow>
                                                        <DataTableRow className="nk-tb-col-tools">
                                                          <div className="tb-odr-btns d-none d-sm-inline">
                                                            <Button onClick={(e) => { e.preventDefault(); open_view_history_modal(item?.inserted_at); }} color="primary" size="sm" className="btn btn-dim">
                                                              View
                                                            </Button>
                                                          </div>
                                                          <Button onClick={(e) => { e.preventDefault(); open_view_history_modal(item?.inserted_at); }} className="btn-pd-auto d-sm-none">
                                                            <Icon name="chevron-right"></Icon>
                                                          </Button>
                                                        </DataTableRow>
                                                      </DataTableItem>
                                                    );
                                                  })
                                                  : null}
                                              </DataTableBody>
                                              <div className="card-inner">
                                                {page_data?.recent_product_inventory?.length > 0 ? (
                                                  <PaginationComponent
                                                    itemPerPage={itemPerPage}
                                                    totalItems={page_data?.recent_product_inventory?.length}
                                                    paginate={paginate}
                                                    currentPage={currentPage}
                                                  />
                                                ) : (
                                                  <div className="text-center">
                                                    <span className="text-silent">No products Inventory History found</span>
                                                  </div>
                                                )}
                                              </div>
                                            </>
                                          )
                                        }
                                        {
                                          historyView === "pdf" && (
                                            <>
                                              <div style={{ height: "90vh", width: "100%" }} className='border-2 border-text-gray-400'>
                                                <PDFViewer height="100%" width="100%" showToolbar>
                                                  <InventoryHistoryPDF page_data={{ ...page_data, processedInventory: processedInventory }} tenant_info={tenant_info} />
                                                </PDFViewer>
                                              </div>
                                            </>
                                          )
                                        }
                                      </div>
                                    </div>
                                  </Card>
                                  <ViewHistoryDetailsModal isOpen={view_history_modal} closeModal={close_view_history_modal} data={selectedHistory} title="Product History Details" />
                                </>
                              )
                            }
                            {
                              activeCardTab === "Reserved Orders" && (
                                <>
                                  {
                                    page_data?.reserved_products?.length > 0 ?
                                      <>
                                        <div className="nk-tb-list is-separate is-medium mb-3 mt-4">
                                          <DataTableHead className="nk-tb-item">
                                            <DataTableRow>
                                              <span className="sub-text">Order</span>
                                            </DataTableRow>
                                            <DataTableRow size="lg">
                                              <span className="sub-text">Units</span>
                                            </DataTableRow>
                                            <DataTableRow size="md">
                                              <span className="sub-text">Color</span>
                                            </DataTableRow>
                                            <DataTableRow size="md">
                                              <span className="sub-text">Size</span>
                                            </DataTableRow>
                                            <DataTableRow size="md">
                                              <span className="sub-text">Order Date</span>
                                            </DataTableRow>
                                            <DataTableRow size="md">
                                              <span className="sub-text">Order Type</span>
                                            </DataTableRow>
                                            <DataTableRow size="md">
                                              <span className="sub-text">Status</span>
                                            </DataTableRow>
                                            <DataTableRow size="md">
                                              <span className="sub-text">Action</span>
                                            </DataTableRow>
                                          </DataTableHead>
                                          {/*Head*/}
                                          {currentReservedOrderItems.length > 0
                                            ? currentReservedOrderItems.map((item) => (
                                              <DataTableItem key={item.id}>
                                                <DataTableRow>
                                                  <Link to={`/${tenant_info.url_prefix}/orders/${item?.order_ref_number}`}>
                                                    <div className="user-card">
                                                      <div className="user-info">
                                                        <span className="tb-lead">
                                                          {item?.order_name || "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                                        </span>
                                                        <span>{item?.order_ref_number || "--"} </span>
                                                      </div>
                                                    </div>
                                                  </Link>
                                                </DataTableRow>
                                                <DataTableRow>
                                                  <div className="user-card">
                                                    <div className="user-info">
                                                      <span className="tb-lead">
                                                        {item?.item_units || "0"}
                                                      </span>
                                                    </div>
                                                  </div>
                                                </DataTableRow>
                                                <DataTableRow>
                                                  <div className="user-card">
                                                    <div className="user-info">
                                                      <span className="tb-lead">
                                                        {item?.item_color || "0"}
                                                      </span>
                                                    </div>
                                                  </div>
                                                </DataTableRow>
                                                <DataTableRow>
                                                  <div className="user-card">
                                                    <div className="user-info">
                                                      <span className="tb-lead">
                                                        {item?.item_size || "0"}
                                                      </span>
                                                    </div>
                                                  </div>
                                                </DataTableRow>
                                                <DataTableRow size="md">
                                                  <div className="user-info">
                                                    <span className="tb-lead">{item?.order_date ? moment(item?.order_date).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                                    {
                                                      item?.order_date_type === app_consts.BACK_DATED_LOWER && (
                                                        <>
                                                          <span className="tb-odr-date">Backdate: {item?.backdated_date ? moment(item?.backdated_date).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                                        </>
                                                      )
                                                    }
                                                  </div>
                                                </DataTableRow>
                                                <DataTableRow size="md">
                                                  {item?.order_date_type ? formatToSentenceCase(item?.order_date_type)?.toUpperCase() : "--"}
                                                </DataTableRow>
                                                <DataTableRow size="md">
                                                  <span className="tb-odr-status">
                                                    <Badge
                                                      color={
                                                        item?.item_status === app_consts.APPROVED_LOWER || item?.item_status === app_consts.DISPATCHED_LOWER
                                                          ? "success"
                                                          : "warning"
                                                      }
                                                      className="badge-dot"
                                                    >
                                                      {item?.item_status ? formatToSentenceCase(item?.item_status)?.toUpperCase() : "--"}
                                                    </Badge>
                                                  </span>
                                                </DataTableRow>
                                                <DataTableRow className="nk-tb-col-tools">
                                                  <div className="tb-odr-btns d-none d-sm-inline">
                                                    <Link to={`/${tenant_info.url_prefix}/orders/${item?.order_ref_number}`}>
                                                      <Button color="primary" size="sm" className="btn btn-dim">
                                                        View
                                                      </Button>
                                                    </Link>
                                                  </div>
                                                  <Button className="btn-pd-auto d-sm-none">
                                                    <Icon name="chevron-right"></Icon>
                                                  </Button>
                                                </DataTableRow>
                                              </DataTableItem>
                                            ))
                                            : null}
                                        </div>
                                        {currentReservedOrderItems.length > 0 && (
                                          <div className="mt-3">
                                            <PaginationComponent
                                              itemPerPage={reservedOrdersPerPage}
                                              totalItems={page_data?.reserved_products?.length}
                                              paginate={paginateReservedOrders}
                                              currentPage={currentReservedOrdersItemsPage}
                                            />
                                          </div>
                                        )}
                                      </>
                                      :
                                      <>
                                        <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Reserved Orders Found."} />
                                      </>
                                  }
                                </>
                              )
                            }
                          </PreviewAltCard>
                        </>
                        :
                        <>
                          <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Product Information Found"} />
                        </>
                    }
                  </>
              }
            </>
        }
      </Content >

      {/* Adjust Stock Modal */}
      < Modal isOpen={adjust_stock_modal} className="modal-dialog-centered" size={"lg"} >
        <ModalHeader toggle={adjust_stock_loading ? "" : close_retrieve_stock_data_modal}>Add Product Stock</ModalHeader>
        <ModalBody>
          <Row className="g-4">
            {
              retrieve_stock_loading ?
                <>
                  <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                    <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>Retrieveing Stock Data...</div>
                    <div className="nk-loader mt-2  w-70 m-auto "></div>
                  </div>
                </>
                :
                <>
                  <Row className="g-4">
                    <TextInput
                      label="Product Name"
                      type="text"
                      id_val="product_name"
                      value={page_data?.name}
                      colSize="6"
                      name="product_name"
                      disabled
                    // handleChange={handleChange}
                    />
                    <TextInput
                      label="SKU No"
                      type="text"
                      id_val="sku_no"
                      value={page_data?.sku_no || "--"}
                      colSize="6"
                      name="sku_no"
                      disabled
                    // handleChange={handleChange}
                    />
                    <Col size={6}>
                      <div className="form-group">
                        <label className="form-label mb-1 text-md" htmlFor="packet_size">
                          Size<span className='text-danger pr-2'>{` *`}</span>
                        </label>
                        <div className="w-100">
                          <RSelect
                            options={packet_size_map_data}
                            className="w-100"
                            placeholder="Search"
                            id="packet_size"
                            onChange={(e) => {
                              setAddProductStockFormData({ ...add_product_stock_form_data, ["packet_size"]: e.value });
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col size={6}>
                      <div className="form-group">
                        <label className="form-label mb-1 text-md" htmlFor="color">
                          Color<span className='text-danger pr-2'>{` *`}</span>
                        </label>
                        <div className="w-100">
                          <RSelect
                            options={colors_map_data}
                            className="w-100"
                            placeholder="Search"
                            id="color"
                            onChange={(e) => {
                              setAddProductStockFormData({ ...add_product_stock_form_data, ["color"]: e.value });
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col size={6}>
                      <div className="form-group">
                        <label className="form-label mb-1 text-md" htmlFor="warehouse_site_id">
                          Warehouse Site<span className='text-danger pr-2'>{` *`}</span>
                        </label>
                        <div className="w-100">
                          <RSelect
                            options={warehouse_site_map_data}
                            className="w-100"
                            placeholder="Search"
                            id="color"
                            onChange={(e) => {
                              setAddProductStockFormData({ ...add_product_stock_form_data, ["warehouse_site_id"]: e.value });
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                    <TextInput
                      label="Units"
                      type="number"
                      id_val="unit"
                      value={add_product_stock_form_data?.units}
                      colSize="6"
                      name="units"
                      handleChange={(e) => {
                        setAddProductStockFormData({ ...add_product_stock_form_data, ["units"]: e.target.value });
                      }}
                    />
                    <Col size={6}>
                      <div className="form-group">
                        <label className="form-label mb-1 text-md" htmlFor="warehouse_site_id">
                          Adjustment Type<span className='text-danger pr-2'>{` *`}</span>
                        </label>
                        <div className="w-100">
                          <RSelect
                            options={[{ label: "Add", value: "add" }, { label: "Subtract", value: "subtract" }]?.map((data) => {
                              return {
                                label: data?.label,
                                value: data?.value
                              };
                            })}
                            className="w-100"
                            placeholder="Search"
                            id="adjustment_type"
                            onChange={(e) => {
                              setAddProductStockFormData({ ...add_product_stock_form_data, ["adjustment_type"]: e.value });
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                    <TextInput
                      label="Adjustement Reason"
                      type="text"
                      id_val="reason"
                      value={add_product_stock_form_data?.reaons}
                      colSize="6"
                      name="reason"
                      handleChange={(e) => {
                        setAddProductStockFormData({ ...add_product_stock_form_data, ["reason"]: e.target.value });
                      }}
                    />
                    {add_product_stock_error && (
                      <div className="mb-3 w-100">
                        <Alert color="danger" className="alert-icon">
                          <Icon name="alert-circle" /> {add_product_stock_error}{" "}
                        </Alert>
                      </div>
                    )}
                    <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
                      <Button onClick={(e) => { e.preventDefault(); handle_submit_add_product_stock(); }} disabled={retrieve_stock_loading || adjust_stock_loading || !(add_product_stock_form_data?.color && add_product_stock_form_data?.packet_size && add_product_stock_form_data?.product_id && add_product_stock_form_data?.units && add_product_stock_form_data?.warehouse_site_id && add_product_stock_form_data?.adjustment_type && add_product_stock_form_data?.reason)} color="primary">
                        {retrieve_stock_loading || adjust_stock_loading ? <Spinner size="sm" color="light" /> : "Adjust Product Stock"}
                      </Button>
                    </Col>
                  </Row>
                </>
            }
          </Row>
        </ModalBody>
      </Modal >
    </>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    width: "300px",
    gap: "8px",
    border: "1px solid #ccc",
    padding: "10px",
    borderRadius: "8px",
  },
  bubbleContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "5px",
  },
  bubble: {
    display: "flex",
    alignItems: "center",
    color: "white",
    padding: "5px 10px",
    borderRadius: "15px",
    fontSize: "14px",
  },
  close: {
    marginLeft: "8px",
    cursor: "pointer",
    fontWeight: "bold",
  },
  input: {
    width: "100%",
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "4px",
  },
};

export default ProductDetails;